export const ERROR_GET_CARDS_SERVER = 'Failed to get credit cards. Please try again later.'
export const ERROR_SAVE_CARD_SERVER = 'Unable to process your card details. Please try again later.'
export const ERROR_CHARGE_CARD_SERVER = 'Failed to charge credit card. Please try again later.'
export const ERROR_CHARGE_UNDER_REVIEW =
  'You currently have a payment under review. Please wait for it to be approved or contact support.'
export const ERROR_DELETE_CARD_SERVER = 'Failed to delete credit card. Please try again later.'
export const ERROR_AUTO_RECHARGE_CARD_SERVER = 'Failed to set auto recharging. Please try again later.'
export const ERROR_GET_BALANCE_SERVER = 'Failed to get the updated balance.'

export const ERROR_GET_RECEIPTS_SERVER = 'Failed to get receipts. Please try again later.'

export const ERROR_GET_INVOICES_SERVER = 'Failed to get invoices. Please try again later.'

export const ERROR_DOWNLOAD_INVOICE_SERVER = 'Failed to download invoice. Please try again later.'

export const ERROR_GENERATE_PROFORMA_INVOICE = 'Failed to download proforma invoice. Please try again later.'

export const ERROR_TRANSFER_FUNDS = 'Failed to transfer funds. Please try again later.'
export const SUCCESS_TRANSFER_FUNDS = 'Funds transferred successfully.'

export const SUCCESS_SAVE_CARD_SERVER = 'Card successfully added to your account.'
export const SUCCESS_CHARGE_CARD_SERVER = 'You successfully added $%AMOUNT% to your account.'
export const UNDER_REVIEW_CHARGE_CARD_SERVER =
  "Your charge requires manual review. You'll be notified once it is approved. Contact support with any questions."
export const SUCCESS_DELETE_CARD_SERVER = 'Your card was successfully deleted.'

export const MIN_THRESHOLD = 10
export const MAX_THRESHOLD = 2000

export const MIN_AMOUNT = 20
export const MAX_AMOUNT = 2000
